module.exports = "<div class=row> <div class=\"col-md-8 col-md-offset-2\"> <form-note></form-note> </div> </div> <div class=progress v-if=$loadingRouteData> <div class=\"progress-bar progress-bar-striped active\" role=progressbar aria-valuenow=45 aria-valuemin=0 aria-valuemax=100 style=\"width: 100%\"> <span class=sr-only>Loading...</span> </div> </div> <div class=\"grid clearfix\" v-if=!$loadingRouteData> <note v-for=\"note in notes\" :note=note track-by=$index> </note> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
 ** module id = 53
 ** module chunks = 0
 **/